import script from "./WeightRecordsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeightRecordsTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__